<template>
  <div>
    <!-- MODAL DE ERROR -->
    <div
      class="modal fade"
      id="infoGifting"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content modal-info-l modal-mg">
          <div class="modal-body img-info-gifting">
            <div class="boton">
              <button
                type="button"
                class="close close-modal-red"
                data-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>

            <template v-if="result == 1">
              <div class="row justify-content-center">
                <div class="col-12">
                  <p class="t-i-gifting-w">
                    LO SENTIMOS, YA NO <br />
                    HAY UNIDADES DISPONIBLES.
                  </p>
                </div>
                <div
                  class="col-12 col-md-12 col-lg-12 col-xl-11 col-sm-12"
                  style="text-align: center"
                >
                  <p class="t-i-gifting-y">
                    ¡INTÉNTALO EN LA PROXIMA PROMOCIÓN!
                  </p>
                </div>
              </div>
            </template>

            <template v-if="result == 2">
              <div class="row justify-content-center">
                <div class="col-12">
                  <p class="t-i-gifting-w">
                    YA REDIMISTE TU REGALO
                  </p>
                </div>
                <div
                  class="col-12 col-md-12 col-lg-12 col-xl-11 col-sm-12"
                  style="text-align: center"
                >
                  <p class="t-i-gifting-y">
                    ¡INTÉNTALO EN LA PROXIMA PROMOCIÓN!
                  </p>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de exito -->

    <div
      class="modal fade"
      id="infoGiftingSuccess"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered ">
        <div class="modal-content modal-info-l modal-mg-success">
          <div class="modal-body img-info-gifting-success">
            <div class="boton">
              <button
                type="button"
                class="close close-modal-while"
                data-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>
            <div class="row">
              <div class="col-12 col-md-8 col-lg-9 col-xl-9">
                <p class="text-gif-success mb-0">¡FELICITACIONES!</p>
                <p class="text-gif-success mb-0">Pronto recibirás tu regalo</p>
              </div>
              <div class="col-12 col-md-4 col-lg-3 col-xl-3">
                <img alt="bien" src="../assets/icon/bien.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  props: ["result"],
  watch: {
    result(newR) {
      if (newR == 3) {
        // 3 es success
        $("#infoGiftingSuccess").modal("show");
      } else if (newR == 2 || newR == 1) {
        $("#infoGifting").modal("show");
      } else if(newR == 4){
        $("#infoGifting").modal("hide");
      }
    },
  },
  mounted() {},
};
</script>

<style>
.modal-mg {
  border-radius: 27px;
}
.modal-mg-success {
  border-radius: 10px;
}
.img-info-gifting {
  border-radius: 22px;
  background-position: center;
  background-image: url("./../assets/img/infoLubricador.jpg");
}
.close-modal-while{
  font-size: 16px;
  color: #dc3545;
}
.close-modal-red {
  font-weight: bold;
  color: white;
}
.text-gif-success{
  color: #dc3545;
  font-family: "GothamBoldItalic", sans-serif;
  font-size: 20px;
}
.t-i-gifting-y {
  padding-bottom: 25px;
  font-size: 30px;
  color: #fdd200;
  font-family: "Gotham-UltraItalic", sans-serif;
}
.t-i-gifting-w {
  padding-top: 40px;
  font-size: 25px;
  color: #fff;
  font-family: "GothamBoldItalic", sans-serif;
}
</style>
